import { ACCEPTED_ASSET_TYPE, createShapesFromFiles, useApp } from '@tldraw/editor'
import { useCallback, useEffect, useState } from 'react'

export function useInsertMedia() {
	const app = useApp()
	const [input, setInput] = useState<HTMLInputElement | null>(null)

	useEffect(() => {
		const input = window.document.createElement('input')
		input.type = 'file'
		input.accept = ACCEPTED_ASSET_TYPE
		input.multiple = true
		input.style.display = 'none'
		document.body.appendChild(input)
		setInput(input)
	}, [])

	return useCallback(() => {
		if (!input) return

		input.onchange = async (e) => {
			const fileList = (e.target as HTMLInputElement).files
			if (!fileList || fileList.length === 0) return
			await createShapesFromFiles(app, Array.from(fileList), app.viewport.center, false)
			input.value = ''
		}
		input.click()
	}, [app, input])
}
